/**
 * 事件詳情的「AI 描述與逐字稿」：管理員開啟照片描述或聲音轉文字後，monitor 產生的文字。
 * 沒有資料（功能沒開、還沒處理、舊版後端回 404）就整段不顯示。
 *
 * API：GET /api/v1/events/{event_id}/insights — 只回已保存檔案的完成結果，權限和事件詳情相同
 */
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import type { MediaInsight } from '@/types/assistant';

export function MediaInsights({ eventId }: { eventId: string }) {
  const insights = useQuery({
    queryKey: ['event-insights', eventId],
    queryFn: () => apiGet<{ insights: MediaInsight[] }>(`/api/v1/events/${encodeURIComponent(eventId)}/insights`),
    staleTime: 30_000,
    retry: false,
  });
  const items = insights.data?.insights ?? [];
  if (items.length === 0) return null;
  return (
    <div>
      <h3 className="mb-2 text-[14px] font-semibold">AI 描述與逐字稿</h3>
      <ul className="space-y-2">
        {items.map((it) => (
          <li key={`${it.media_id}-${it.kind}`} className="rounded-md border border-border p-3">
            <div className="mb-1.5 flex flex-wrap items-center gap-2">
              <Badge variant="info">{it.kind === 'caption' ? '照片描述' : '逐字稿'}</Badge>
              <span className="min-w-0 break-all font-mono text-[11.5px] text-muted-foreground">{it.filename}</span>
            </div>
            <p className="whitespace-pre-line text-[13px] leading-relaxed">{it.text}</p>
          </li>
        ))}
      </ul>
      <p className="mt-2 text-[11.5px] text-muted-foreground">由模型自動產生，可能有誤，請以原始檔案為準。</p>
    </div>
  );
}
